import { SupportChatProps } from '@acme/domains';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { ChatWindow } from '../../../features/chatWindow';
import { ChatToggle } from './chatToggle/chatToggle';

export const SupportChatModal = (props: SupportChatProps) => {
  const chatWindowRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => setIsOpen((prev) => !prev);
  const closeChat = () => setIsOpen(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        chatWindowRef.current &&
        !chatWindowRef.current.contains(event.target as Node) &&
        !(event.target as Element).closest('.chat-toggle')
      ) {
        closeChat();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <ChatToggle onClick={toggleChat} hasNewMessages={false} />
      {isOpen &&
        createPortal(
          <div
            ref={chatWindowRef}
            className="fixed left-64 bottom-4 w-[375px] h-[800px] z-50"
          >
            <div className="flex flex-col rounded-lg border bg-white h-full">
              <div className="bg-white p-4 flex justify-between items-center border-b border-gray-200">
                <div className="flex items-center font-semibold text-lg leading-relaxed tracking-normal text-gray-900">
                  Чат поддержки
                </div>
                <button
                  onClick={closeChat}
                  className="text-gray-400 hover:text-black text-xl w-3 h-3 flex items-center justify-center"
                >
                  ×
                </button>
              </div>
              <ChatWindow
                className="flex-1 min-h-0"
                autoScrollToBottomOnMount
                api={{
                  companionLabelText: props.companionLabelText,
                  loadChatHistory: props.loadChatHistory,
                  sendMessage: props.sendMessage,
                  getAttachmentReq: props.getAttachmentReq,
                }}
              />
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
